import css from 'styled-jsx/css';

export default css`

.errorScreen{
  margin: 0 30px 30px 30px;
  }
  .errorScreen .errorTitle{
    font-size:1.375rem;
    font-family: var(--regular-font);
    color: var(--color-gp--blue);
    text-align: center;
    margin-top: 15px;
  }
  
  .errorScreen .errorSubtitle{
    margin-top:20px;
    font-family: var(--regular-font);
    color: var(--color-gp--grey7);
    text-align:center;
  }
  
  .errorScreen .errorMessage{
    font-size: 1rem;
    font-family: var(--regular-font);
    color:var(--color-gp--grey5);
    text-align: center;
    margin-top: 16px;
  }
  
  .errorScreen .errorImage{
    margin-top: 35px;
    text-align: center;
    .fatalError{
      width:200px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  
  .errorScreen .buttonTCOL{
    margin-top: 25px;
    margin-bottom: 30px;
    text-align: center;
  }
  .errorScreen .imageError {
    display: inline;
  }
  
  
  /* MAQUETACIÓN NOVUM CATALOGO */
  .mainContent.novumCatalogo {
    background-color: var(--color-gp--white);
    min-width: 100vw;
    min-height: 100vh;
  }
  .originCatalogueNovum .errorScreen {
    padding-top: 2.9rem;
    .errorImage{
      text-align: left;
    }
      .fatalError{
        width:200px;
        margin-left: auto;
        margin-right: auto;
      }
      .imageError{
        width: 65px;
      }
    .errorTitle {
      padding-top: 1.25rem;
      color: var(--color-gp--cool-grey);
      font-family: 'Roboto', sans-serif;
      font-size: 1.5rem;
      text-align: left;
      font-weight: 300;
    }
    .errorSubtitle,
    .errorMessage {
      font-family: 'Roboto', sans-serif;
      color: #757575;
      font-size: 1.375rem;
      font-weight: 400;
      text-align: left;
    }
  }
  
`;